function NovaPoshtaMain() {

  console.log('npm-load');
  const apiKey            = NP_API_KEY;
  const endpointNP        = 'http://api.novaposhta.ua/v2.0/json/';
  const country           = 'Ukraine';
  const provider          = 'TRM Custom';
  const quickIndices      = quickCityIndices.split(' ');
  const bodyNP            = document.getElementById('nova-poshta');
  const deliveryVariants  = document.getElementById('deliveryVariants');
  const deliveryTypes     = document.querySelectorAll('input[type="radio"][name="id"]');
  const courierTypes      = document.querySelectorAll('input[name="courier-type"]');
  let deliveryType        = document.querySelector('input[type="radio"][name="id"]:checked').getAttribute('data-type');

  let isDelivery          = false;
  let address;
  let address_pickup      = false;
  // Wraps
  const wrapWarehouse     = document.querySelector('.warehouse-wrap');
  const wrapAddresses     = document.querySelector('.address-wrap');
  // Inputs
  const inputCity         = document.getElementById('city-search');
  const inputWarehouse    = document.getElementById('warehouse-search');
  const inputStreet       = document.getElementById('address-street');
  const inputBuild        = document.getElementById('address-build');
  const inputFlat         = document.getElementById('address-flat');

  const inputEntrance         = document.getElementById('address-entrance');
  const inpuFloor         = document.getElementById('address-floor');

  const inputFields       = document.querySelectorAll('.form-group input');
  const filterFields      = document.querySelectorAll('.dropdown-filter');

  const cityErrorEl       = document.querySelector('.city-wrap .input-error');
  const warehouseErrorEl  = document.querySelector('.warehouse-wrap .input-error');
  const streetErrorEl     = document.querySelector('.address-wrap .input-error');
  const clearCity         = document.querySelector(".city-wrap .clear");
  const clearWarehouse    = document.querySelector(".warehouse-wrap .clear");
  const clearStreet       = document.querySelector(".form-street .clear");
  const cartUrl           = deliveryVariants.getAttribute('data-carturl');

  const properties        = {_provider: provider, _country: country};

  let dataCities, dataWarehouses, dataStreet, addressCity, addressZip, addressStreet, addressBuild, addressFlat, cityData, warehouseData;
  //wrapWarehouse.classList.add('d-none');
  //wrapAddresses.classList.add('d-none');

  // Add these functions near the top of your code
  const WAREHOUSE_DATA_KEY = 'np_warehouse_data';
  const CITY_REF_KEY = 'np_city_ref';

  // Storage management functions
  const STORAGE_KEYS = {
    WAREHOUSE: 'np_warehouse_data',
    CITY: 'np_city_ref'
  };

  const MAX_STORAGE_ITEMS = 5;

  function cleanupStorage() {
    try {
      const allItems = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith('np_')) {
          try {
            const value = localStorage.getItem(key);
            const data = JSON.parse(value);
            allItems.push({
              key,
              timestamp: data.timestamp || 0
            });
          } catch (e) {
            localStorage.removeItem(key);
          }
        }
      }

      if (allItems.length >= MAX_STORAGE_ITEMS) {
        allItems.sort((a, b) => a.timestamp - b.timestamp);
        const itemsToRemove = allItems.slice(0, allItems.length - MAX_STORAGE_ITEMS + 1);
        itemsToRemove.forEach(item => localStorage.removeItem(item.key));
      }
    } catch (e) {
      console.warn('Storage cleanup failed:', e);
      // Clear all NP related items as fallback
      clearNPStorage();
    }
  }

  function clearNPStorage() {
    Object.values(STORAGE_KEYS).forEach(key => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        console.warn(`Failed to remove ${key}:`, e);
      }
    });
  }

  function saveWarehouseData(cityRef, data) {
    try {
      cleanupStorage();

      const storageData = {
        cityRef,
        warehouses: data,
        timestamp: Date.now()
      };

      localStorage.setItem(STORAGE_KEYS.WAREHOUSE, JSON.stringify(storageData));
      return true;
    } catch (e) {
      console.warn('Failed to save warehouse data:', e);
      clearNPStorage();
      return false;
    }
  }

  function getStoredWarehouseData(cityRef) {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.WAREHOUSE);
      if (!stored) return null;

      const data = JSON.parse(stored);
      const isValid =
        data.cityRef === cityRef &&
        Date.now() - data.timestamp < 24 * 60 * 60 * 1000;

      return isValid ? data.warehouses : null;
    } catch (e) {
      console.warn('Error reading warehouse data:', e);
      clearNPStorage();
      return null;
    }
  }

  if (inputCity.value.length > 0 && inputWarehouse.value.length > 0 ) {
    checkoutButton.classList.remove('disabled');
    checkoutButton.disabled = false;
  } else if (inputCity.value.length > 0 && inputStreet.value.length > 0 ) {
    checkoutButton.classList.remove('disabled');
    checkoutButton.disabled = false;
  } else {
    // checkoutButton.classList.add('disabled');
    // checkoutButton.disabled = true;
  }

  //document.querySelector('.quick-city-wrap').innerHTML = '';


  /*== update cart note  ==*/
  async function updateCartNote() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({note: "null"}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
  }
  //if(pageType == 'sidebar') btnHover();

  /*== update cart attribute  ==*/
  async function updateCartDeliveryAttr(data) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: data}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const jsonResponse = await response.json();

      if (jsonResponse.attributes._delivery_courier_new == null){
        document.querySelector('.mink-btn').click();
      }

      if (!jsonResponse.attributes._delivery_city == null ||
        typeof jsonResponse.attributes._delivery_city == undefined ||
        jsonResponse.attributes._delivery_courier_new == null) return jsonResponse;

      if (!document.querySelector('.np-free-text') || !document.querySelector('.mink-outside-kiev')) return jsonResponse;

      const npFreeText = document.querySelector('.np-free-text');
      const minkOutsideKiev = document.querySelector('.mink-outside-kiev');
      const minkButton = document.querySelector('.mink-btn');
      const npButton = document.querySelector('.np-btn');
      const deliveryWidgetCart = document.querySelector('.delivery-widget-cart');
      const minkNotify = document.querySelector('.mink-notify');
      const hiddenMask = document.querySelector('.hidden-click-mask');

      const hideAll = () => {
        npFreeText.classList.add('tw-hidden');
        minkOutsideKiev.classList.add('tw-hidden');
      }

      const city = jsonResponse.attributes._delivery_city;
      const deliveryType = jsonResponse.attributes._delivery_courier_new;

      hideAll();



      if (city != 'м. Київ, Київська обл.' && deliveryType != 'np') {
        minkOutsideKiev.classList.remove('tw-hidden');
      }

      if (deliveryType == 'np' && document.querySelector('[data-type="courier"]').checked || document.querySelector('[data-type="branch"]').checked) {
        if (!document.querySelector('[data-type="branch"]').checked) {
          npFreeText.classList.remove('tw-hidden');
        }
        deliveryWidgetCart.classList.add('tw-hidden');
      } else {
        deliveryWidgetCart.classList.remove('tw-hidden');
      }

      // Only apply Mink restrictions if minkAllCities is false
      if (!window.minkAllCities && !city?.includes('Київ')) {
        minkButton.classList.add('courier-disabled');
        npButton.click();
        hiddenMask.classList.remove('tw-hidden');

        document.addEventListener('click', (e) => {
          if (e.target.closest('.hidden-click-mask')) return;
          minkNotify.classList.add('tw-hidden');
        });
      } else {
        minkButton.classList.remove('courier-disabled');
        minkNotify.classList.add('tw-hidden');
        hiddenMask.classList.add('tw-hidden');
      }

      if (document.querySelector('.input-city').value == '') {
        npFreeText.classList.add('tw-hidden');
        minkOutsideKiev.classList.add('tw-hidden');
      }

      return jsonResponse;
    } catch (error) {
      console.error('Error updating cart attributes:', error);
      throw error;
    }
  }


  /*== Request API ==*/
  async function reqAPI(data) {
    try {
      const response = await fetch(endpointNP, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      //throw error;
      console.log('error');
    }
  }

  window.globalReqAPI = reqAPI;

  reqAPI({"apiKey": apiKey,"modelName": "Address","calledMethod": "searchSettlements","methodProperties": {"CityName" : quickIndices[0],"Limit" : "1","Page" : "1"}})
    .then(res => {

      console.log(res.success);

      if (res.success) {

        /*== check selected delivery type in cart attribute ==*/
        fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

          wrapWarehouse.classList.add('d-none');
          // wrapAddresses.classList.add('d-none');
          //alert('1');

          if (data.attributes._delivery_type) {
            isDelivery = true;
            deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
            document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
            deliveryType = data.attributes._delivery_type;
            //console.log('type',deliveryType);
            if(deliveryType == 'courier') {
              filterExclusion = '-1';
              wrapAddresses.classList.remove('d-none');
              properties._delivery_type = deliveryType;
              checkoutButton.disabled = false;
              checkoutButton.classList.remove('disabled');
              updateCartDeliveryAttr(properties);
            }
            if(deliveryType == 'branch') {
              filterExclusion = '0';
              wrapWarehouse.classList.remove('d-none');
              properties._delivery_type = deliveryType;
              updateCartDeliveryAttr(properties);
            }
          }
          if (!isDelivery) {
            //console.log('nodelivery');
            wrapWarehouse.classList.remove('d-none');
            properties._delivery_type = deliveryType;
            filterExclusion = '0';
            updateCartDeliveryAttr(properties);
          }

          /*
          properties._delivery_courier_address              = null;
          properties._delivery_courier_street               = null;
          properties._delivery_courier_house                = null;
          properties._delivery_courier_flat                 = null;
          properties._delivery_street_Ref                   = null;
          properties._delivery_city                         = null;
          properties._delivery_city_Area                    = null;
          properties._delivery_city_Ref                     = null;
          properties._delivery_warehouse                    = null;
          properties._delivery_warehouse_zip                = null;
          properties._delivery_warehouse_name               = null;
          properties._delivery_warehouse_address            = null;
          properties._delivery_warehouse_CityRef            = null;
          properties._delivery_warehouse_Number             = null;
          properties._delivery_warehouse_Ref                = null;
          properties._delivery_warehouse_SettlementRef      = null;
          properties._delivery_warehouse_TypeOfWarehouse    = null;


          updateCartDeliveryAttr(properties);
          */
          //updateCartNote();
        })

        /*== check changes delivery type ==*/
        courierTypes.forEach(function(el){
          el.addEventListener("change", async function(){
            const selectedValue = this.value;
            const cityWrapper = document.querySelector('.form-city');
            const quickCityWrap = document.querySelector('.quick-city-wrap');
            const npFieldsWrap = document.querySelector('.np-fields-wrap');
            const warehouseWrap = document.querySelector('.warehouse-wrap');
            const addressWrap = document.querySelector('.address-wrap');
            const extraFields = document.querySelectorAll('.form-entrance, .form-floor');
            const cityInput = document.querySelector('#city-search');
            const npRadioWrap = document.querySelector('.np-fields-wrap');

            // Reset NP radio selection when switching courier types
            if (npRadioWrap) {
              const npRadios = npRadioWrap.querySelectorAll('input[type="radio"]');
              npRadios.forEach(radio => radio.checked = false);
            }

            if (selectedValue === 'mink') {
              // Hide NP specific elements
              quickCityWrap.classList.add('tw-hidden');
              npFieldsWrap.classList.add('tw-hidden');
              warehouseWrap.classList.add('tw-hidden');

              // Show address fields and extra fields for Mink
              addressWrap.classList.remove('tw-hidden');
              extraFields.forEach(field => field.classList.remove('tw-hidden'));

              // Update cart attributes for Mink courier
              await updateCartDeliveryAttr({
                _delivery_courier_new: 'mink',
                _delivery_type: 'courier'
              });
            } else {
              // Show NP specific elements
              quickCityWrap.classList.remove('tw-hidden');
              npFieldsWrap.classList.remove('tw-hidden');

              // Set default NP radio selection
              const courierRadio = document.querySelector('#type-courier');
              if (courierRadio) {
                courierRadio.checked = true;
                deliveryType = 'courier';
              }

              // Hide extra fields for Nova Poshta
              extraFields.forEach(field => field.classList.add('tw-hidden'));

              // Update cart attributes for NP courier
              await updateCartDeliveryAttr({
                _delivery_courier_new: 'np',
                _delivery_type: 'courier'
              });
            }
          });
        });
        // Also add validation call to your existing change handlers
        deliveryTypes.forEach(function(el) {
          el.addEventListener("change", function() {
            validateDeliveryFields();
          });
        });

        courierTypes.forEach(function(el) {
          el.addEventListener("change", function() {
            validateDeliveryFields();
          });
        });
        deliveryTypes.forEach(function(el){
          console.log('check changes delivery type ');
          el.addEventListener("change", function(){
            const warehouseWrap = document.querySelector('.warehouse-wrap');
            const extraFields = document.querySelectorAll('.form-entrance, .form-floor');
            const courierNew = document.querySelector('#type-courier-new');
            const addressWrap = document.querySelector('.address-wrap');  // Add this line if not present

            deliveryType = this.getAttribute('data-type');

            if (deliveryType === 'branch') {
              warehouseWrap.classList.remove('tw-hidden');
              addressWrap.classList.add('tw-hidden');  // Add this line
              document.querySelector('#type-courier-new-np').checked = true;  // Force NP selection
              if (!courierNew.checked) {
                addressWrap.classList.add('tw-hidden');
              }
            } else if (deliveryType === 'courier') {
              warehouseWrap.classList.add('tw-hidden');
              addressWrap.classList.remove('tw-hidden');

              // Show extra fields only for Mink courier
              if (courierNew.checked) {
                extraFields.forEach(field => field.classList.remove('tw-hidden'));
                document.querySelector('[data-type="courier"]').click();
              } else {
                extraFields.forEach(field => field.classList.add('tw-hidden'));
              }
            }

            wrapWarehouse.classList.add('d-none');
            // wrapAddresses.classList.add('d-none');
            inputFields.forEach(function(e){ e.value = '';})
            cityErrorEl.innerHTML = '';
            warehouseErrorEl.innerHTML = '';
            streetErrorEl.innerHTML = '';
            filterFields.forEach(function(f){
              while(f.firstChild){ filter.removeChild(filter.firstChild);}
            });

            properties._delivery_type = deliveryType;
            if (deliveryType == 'branch') {
              properties._delivery_method = methodBranch;
              filterExclusion = '0';
              wrapWarehouse.classList.remove('d-none');
              // checkoutButton.classList.add('disabled');
              // checkoutButton.disabled = true;
            }
            if (deliveryType == 'courier') {
              properties._delivery_method = methodCourier;
              filterExclusion = '-1';
              wrapAddresses.classList.remove('d-none');
              checkoutButton.classList.remove('disabled');
              checkoutButton.disabled = false;
            }
            properties._delivery_courier_address              = null;
            properties._delivery_street_Ref                   = null;
            properties._delivery_city                         = null;
            properties._delivery_city_Area                    = null;
            properties._delivery_city_Ref                     = null;
            properties._delivery_warehouse                    = null;
            properties._delivery_warehouse_zip                = null;
            properties._delivery_warehouse_name               = null;
            properties._delivery_warehouse_address            = null;
            properties._delivery_warehouse_CityRef            = null;
            properties._delivery_warehouse_Number             = null;
            properties._delivery_warehouse_Ref                = null;
            properties._delivery_warehouse_SettlementRef      = null;
            properties._delivery_warehouse_TypeOfWarehouse    = null;
            updateCartDeliveryAttr(properties).then(function() {console.response}).catch(alert);
          })
        })

        /*== text input clear ==*/
        document.querySelectorAll(".clear").forEach(function(el, index){
          el.addEventListener('click', function() {
            document.querySelectorAll(".form-group input")[index].value = '';
            document.querySelectorAll(".form-group input")[index].readOnly = false;
            //if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
            document.querySelectorAll(".form-group input")[index].focus();
            this.classList.add('d-none');
            if(index == 0) {
              document.querySelectorAll(".form-group").forEach(function(el) {
                el.querySelector('input').value = '';
                el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
                el.querySelector("input").readOnly = false;
              })
            }
            //if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
            filterFields.forEach(function(f){clearList(f)});
            bodyNP.classList.remove('filter-active');
            warehouseErrorEl.innerHTML = '';
            cityErrorEl.innerHTML = '';
            streetErrorEl.innerHTML = '';
            // checkoutButton.classList.add('disabled');
            // checkoutButton.disabled = true;
          });
        })

        /*== remove filter result list ==*/
        function clearList(filter) {
          while(filter.firstChild){filter.removeChild(filter.firstChild)}
        }
        function pointPrefix(data) {
          switch (data) {
            case 'Postomat':
              pointType = 'Поштомат';
              break;
            case 'Branch':
              pointType = 'Відділення';
              break;
            default:
              pointType = data;
              break;
          }
          return pointType;
        }
        function stripslashes_n(str) {
          return str.replace(/'/g,`ʹ`);
        }


        /*== search city  ==*/
        function searchCity() {
          let filter = document.querySelector('#city_filter');
          let filterQuickCity = document.querySelector('.quick-city-wrap');
          let dataQuickCity;
          let quickOutput = '';
          let output_prev = 0;

          /* Start Quick City */
          clearList(filterQuickCity);
          quickIndices.forEach(function(qСity, index){
            reqAPI({"apiKey": apiKey,"modelName": "Address","calledMethod": "searchSettlements","methodProperties": {"CityName" : qСity,"Limit" : "1","Page" : "1"}})
              .then(function(ress) {
                console.log(ress.data[0].Addresses[0]);
                dataQuickCity = ress.data[0].Addresses[0];
                quickOutput = `<a data-val='`+stripslashes_n(JSON.stringify(dataQuickCity))+`' class='quick-city-link' href='javascript:void(0)' style='display:block; order:`+index+`;'>`+ dataQuickCity.MainDescription + `</a>`;
                document.querySelector('.quick-city-wrap').insertAdjacentHTML('afterbegin',quickOutput);
              })
              .catch();
          });

          setTimeout(function() {
            document.querySelectorAll('a.quick-city-link').forEach(function(city){
              city.addEventListener("click", function(){
                clearCity.classList.remove('d-none');
                inputWarehouse.readOnly = false;
                document.querySelectorAll(".form-group").forEach(function(el){
                  if (!el.classList.contains('form-city')) {
                    el.querySelector('input.form-control').value = '';
                    el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
                  }
                });

                cityData = JSON.parse(this.getAttribute('data-val'));
                addressCity = cityData.MainDescription;
                inputCity.value = cityData.Present;
                properties._delivery_city = cityData.Present;
                properties._delivery_city_Ref = cityData.DeliveryCity;
                updateCartDeliveryAttr(properties).then(function(cart) {}).catch(alert);
                clearList(filter);

                if (deliveryType == 'branch' && cityData.DeliveryCity) {
                  reqAPI({"apiKey": apiKey,"modelName": "Address","calledMethod": "getWarehouses","methodProperties": {"CityRef" : cityData.DeliveryCity }})
                    .then(function(res) {
                      console.log(res.data);
                      dataWarehouses = res.data;
                      searchWarehouse(dataWarehouses);
                    })
                    .catch(alert);
                } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
                  searchStreet(cityData.DeliveryCity);
                }
              });
            });
          }, 1500);

          if (inputCity.getAttribute('data-ref').length > 0) {
            let cityRef = inputCity.getAttribute('data-ref');
            if (deliveryType == 'branch') {
              inputWarehouse.readOnly = false;
              reqAPI({"apiKey": apiKey,"modelName": "Address","calledMethod": "getWarehouses","methodProperties": {"CityRef" : cityRef }})
                .then(function(res) {
                  dataWarehouses = res.data;
                  searchWarehouse(dataWarehouses);
                })
                .catch(alert);
            } else if (deliveryType == 'courier') {
              inputStreet.readOnly = false;
              searchStreet(cityRef);
            }
          }

          inputCity.addEventListener("keyup", function(event) {
            if(event.key != 'ArrowLeft' && event.key != 'ArrowRight' && !inputCity.readOnly) {
              let searchField = this.value;
              inputWarehouse.value = inputStreet.value = '';
              inputWarehouse.readOnly = false;
              document.getElementById('warehouse_filter').classList.remove('active');
              document.getElementById('street_filter').classList.remove('active');
              clearCity.classList.remove('d-none');

              if(searchField === '' || searchField === ' ') {
                clearList(filter);
                bodyNP.classList.remove('filter-active');
                cityErrorEl.innerHTML = '';
                clearCity.classList.add('d-none');
                output_prev = 0;
                return;
              }

              const isMinkCourier = document.querySelector('#type-courier-new').checked;

              if (isMinkCourier) {
                fetch(`https://vr.mink.in.ua/get_cities?city=${searchField}`)
                  .then(res => res.json())
                  .then(data => {
                    clearList(filter);
                    let output = '';

                    if (data && data.items && data.items.length > 0) {
                      data.items.forEach(val => {
                        output += `<a 
                        data-main="${val.city}"
                        data-present="${val.cityDetailed}"
                        data-ref="${val.osmId}"
                        data-latitude="${val.latitude}"
                        data-longitude="${val.longitude}"
                        class="city-link" 
                        href="javascript:void(0)" 
                        style="display:block;"
                      >${val.cityDetailed}</a>`;
                      });

                      filter.insertAdjacentHTML('afterbegin', output);
                      bodyNP.classList.add('filter-active');
                      document.getElementById('city_filter').classList.add('active');
                      cityErrorEl.innerHTML = '';

                      document.querySelectorAll('a.city-link').forEach(city => {
                        city.addEventListener("click", function() {
                          bodyNP.classList.remove('filter-active');
                          document.getElementById('city_filter').classList.remove('active'); // Add this line
                          clearCity.classList.remove('d-none');
                          inputCity.readOnly = true;
                          inputCity.value = this.getAttribute('data-present');
                          clearList(filter); // Add this line to clear the dropdown

                          properties._delivery_city = this.getAttribute('data-present');
                          properties._delivery_city_name = this.getAttribute('data-main');
                          properties._delivery_city_Ref = this.getAttribute('data-ref');
                          properties._delivery_latitude = this.getAttribute('data-latitude');
                          properties._delivery_longitude = this.getAttribute('data-longitude');

                          updateCartDeliveryAttr(properties).then(() => {
                            if (deliveryType === 'courier') {
                              inputStreet.readOnly = false;
                              searchStreet(this.getAttribute('data-ref'));
                            }
                          }).catch(alert);
                        });
                      });
                    } else {
                      cityErrorEl.innerHTML = alertCity;
                    }
                  })
                  .catch(error => {
                    console.error('Error fetching cities:', error);
                    cityErrorEl.innerHTML = alertKeyboard;
                  });
              } else {
                reqAPI({
                  "apiKey": apiKey,
                  "modelName": "Address",
                  "calledMethod": "searchSettlements",
                  "methodProperties": {
                    "CityName": searchField,
                    "Limit": "150",
                    "Page": "1"
                  }
                })
                  .then(function(res) {
                    console.log(res.data[0].Addresses);
                    dataCities = res.data[0].Addresses;
                    if(dataCities.length > 0) {
                      clearList(filter);
                      cityErrorEl.innerHTML = '';
                    } else {
                      if(output_prev>0) cityErrorEl.innerHTML = alertCity;
                    }
                  })
                  .catch(function() {
                    console.log('error');
                    clearList(filter);
                    cityErrorEl.innerHTML = alertKeyboard;
                  });

                setTimeout(function() {
                  if (dataCities.length > 0) {
                    let output = '';
                    let count = 1;
                    dataCities.forEach(function(val){
                      let linkClass = (val.Warehouses == 0 && deliveryType == 'branch' ) ? 'd-none' : '';
                      output += `<a data-val='`+stripslashes_n(JSON.stringify(val))+`' class='city-link `+ linkClass +`' href='javascript:void(0)' style='display:block;'>`+ val.Present + `</a>`;
                      if (count%1 == 0) output += '';
                      count++;
                    });

                    filter.insertAdjacentHTML('afterbegin', output);
                    if (output_prev > 0) {
                      bodyNP.classList.add('filter-active');
                      document.getElementById('city_filter').classList.add('active');
                    }
                    document.querySelectorAll('a.city-link').forEach(function(city){
                      city.addEventListener("click", function(){
                        bodyNP.classList.remove('filter-active');
                        document.querySelector('.city-wrap .input-error').innerHTML = "";
                        cityData = JSON.parse(this.getAttribute('data-val'));
                        addressCity = cityData.MainDescription;
                        inputCity.value = cityData.Present;
                        properties._delivery_city = cityData.Present;
                        properties._delivery_city_Ref = cityData.DeliveryCity;
                        updateCartDeliveryAttr(properties).then(function(cart) {
                          console.log(cart);
                        }).catch(alert);
                        clearList(filter);

                        if (deliveryType == 'branch' && cityData.DeliveryCity ) {
                          reqAPI({
                            "apiKey": apiKey,
                            "modelName": "Address",
                            "calledMethod": "getWarehouses",
                            "methodProperties": {"CityRef" : cityData.DeliveryCity }
                          })
                            .then(function(res) {
                              dataWarehouses = res.data;
                              searchWarehouse(dataWarehouses);
                            })
                            .catch(alert);
                        } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
                          searchStreet(cityData.DeliveryCity);
                        }
                      });
                    });
                    output_prev = output.length;
                  }
                }, 500);
              }
            }
          });
        }

        window.globalSearchCity = searchCity;

        /*== search branch/postomat  ==*/
        function searchWarehouse(data) {
          if (!data || !data.length) {
            console.log('No warehouse data available');
            return;
          }

          // Store data only if storage is available
          if (properties._delivery_city_Ref) {
            saveWarehouseData(properties._delivery_city_Ref, data);
          }
          const wrapWarehouse = document.querySelector('.warehouse-wrap');
          const filter = document.querySelector('#warehouse_filter');
          const warehouseErrorEl = document.querySelector('.warehouse-wrap .input-error');
          wrapWarehouse.classList.remove('d-none');

          // Create input element reference before using it in event handlers
          const inputWarehouse = document.querySelector('#warehouse-search');
          const newInput = inputWarehouse.cloneNode(true);
          inputWarehouse.parentNode.replaceChild(newInput, inputWarehouse);

          function handleWarehouseSelection(warehouseData) {
            // Update input
            newInput.value = warehouseData.Description;
            newInput.setAttribute('readonly', true);

            // Update properties
            properties._delivery_warehouse = warehouseData.Description;
            properties._delivery_warehouse_zip = '12345';
            properties._delivery_warehouse_name = pointPrefix(warehouseData.CategoryOfWarehouse) + ':' + warehouseData.Number;
            properties._delivery_warehouse_address = warehouseData.ShortAddress;
            properties._delivery_warehouse_CityRef = warehouseData.CityRef;
            properties._delivery_warehouse_Number = warehouseData.Number;
            properties._delivery_warehouse_Ref = warehouseData.Ref;
            properties._delivery_warehouse_SettlementRef = warehouseData.SettlementRef;
            properties._delivery_warehouse_TypeOfWarehouse = warehouseData.TypeOfWarehouse;

            // Update cart and UI
            updateCartDeliveryAttr(properties)
              .then(() => {
                checkoutButton.classList.remove('disabled');
                checkoutButton.disabled = false;
                filter.classList.remove('active');
                clearList(filter);
              })
              .catch(console.error);
          }

          newInput.addEventListener("keyup", function(event) {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') return;

            const searchField = this.value;
            document.querySelector('.warehouse-wrap .clear')?.classList.remove('d-none');

            if (!searchField) {
              clearList(filter);
              return;
            }

            reqAPI({
              "apiKey": apiKey,
              "modelName": "Address",
              "calledMethod": "getWarehouses",
              "methodProperties": {
                "CityRef": properties._delivery_city_Ref,
                "FindByString": searchField,
                "Limit": "50"
              }
            })
              .then(res => {
                if (!res.success || !res.data) {
                  warehouseErrorEl.innerHTML = alertWarehouse;
                  return;
                }

                clearList(filter);

                const output = res.data.map(val => `
              <a data-val='${stripslashes_n(JSON.stringify(val))}' 
                 class='warehouse-link' 
                 href='javascript:void(0)' 
                 style='display:block;'>${val.Description}</a>
            `).join('');

                filter.insertAdjacentHTML('afterbegin', output);
                filter.classList.add('active');
                warehouseErrorEl.innerHTML = '';

                // Add click handlers for warehouse selection
                document.querySelectorAll('a.warehouse-link').forEach(warehouse => {
                  warehouse.addEventListener("click", function() {
                    const warehouseData = JSON.parse(this.getAttribute('data-val'));
                    handleWarehouseSelection(warehouseData);
                  });
                });
              })
              .catch(error => {
                console.error('Error fetching warehouses:', error);
                warehouseErrorEl.innerHTML = alertKeyboard;
              });
          });

          // Store the data in localStorage for future use
          if (properties._delivery_city_Ref) {
            localStorage.setItem('np_warehouse_data', JSON.stringify({
              cityRef: properties._delivery_city_Ref,
              warehouses: data,
              timestamp: Date.now()
            }));
          }
        }

        // Clear warehouses when city changes
        document.querySelectorAll('a.city-link').forEach(city => {
          city.addEventListener('click', function() {
            const warehouseInput = document.querySelector('#warehouse-search');
            if (warehouseInput) {
              warehouseInput.value = '';
              warehouseInput.removeAttribute('readonly');
            }
            clearList(document.querySelector('#warehouse_filter'));
          });
        });

        function updateWarehouseDropdown(warehouses, filter) {
          clearList(filter);

          let output = '';
          warehouses.forEach(val => {
            output += `<a 
            data-val='${stripslashes_n(JSON.stringify(val))}' 
            class='warehouse-link' 
            href='javascript:void(0)' 
            style='display:block;'
          >${val.Description}</a>`;
          });

          filter.insertAdjacentHTML('afterbegin', output);
          filter.classList.add('active');
          warehouseErrorEl.innerHTML = '';

          // Add click handlers for warehouse selection
          document.querySelectorAll('a.warehouse-link').forEach(warehouse => {
            warehouse.addEventListener("click", function() {
              const warehouseData = JSON.parse(this.getAttribute('data-val'));

              // Update input
              newInput.value = warehouseData.Description;
              newInput.setAttribute('readonly', true);

              // Update properties
              updateWarehouseProperties(warehouseData);

              // Update cart and UI
              updateCartDeliveryAttr(properties)
                .then(() => {
                  checkoutButton.classList.remove('disabled');
                  checkoutButton.disabled = false;
                  filter.classList.remove('active');
                  clearList(filter);
                })
                .catch(console.error);
            });
          });
        }

        // Helper function to update warehouse properties
        function updateWarehouseProperties(warehouseData) {
          properties._delivery_warehouse = warehouseData.Description;
          properties._delivery_warehouse_zip = '12345';
          properties._delivery_warehouse_name = pointPrefix(warehouseData.CategoryOfWarehouse) + ':' + warehouseData.Number;
          properties._delivery_warehouse_address = warehouseData.ShortAddress;
          properties._delivery_warehouse_CityRef = warehouseData.CityRef;
          properties._delivery_warehouse_Number = warehouseData.Number;
          properties._delivery_warehouse_Ref = warehouseData.Ref;
          properties._delivery_warehouse_SettlementRef = warehouseData.SettlementRef;
          properties._delivery_warehouse_TypeOfWarehouse = warehouseData.TypeOfWarehouse;
        }

        // Initialize warehouse search on page load if city is already selected
        document.addEventListener('np-widget-loaded', function() {
          const cityRef = document.querySelector('#city-search')?.getAttribute('data-ref');
          if (cityRef) {
            const storedData = getStoredWarehouseData(cityRef);
            if (storedData) {
              searchWarehouse(storedData);
            } else {
              // Fetch fresh data if stored data is not available
              reqAPI({
                "apiKey": apiKey,
                "modelName": "Address",
                "calledMethod": "getWarehouses",
                "methodProperties": {"CityRef": cityRef}
              })
                .then(res => {
                  if (res.success) {
                    dataWarehouses = res.data;
                    searchWarehouse(dataWarehouses);
                  }
                })
                .catch(console.error);
            }
          }
        });



        /*== search street  ==*/
        function searchStreet(cityRef) {
          wrapAddresses.classList.remove('d-none');
          const filter = document.querySelector('#street_filter');
          const streetPref = '';
          let dataStreet = false;

          inputStreet.addEventListener("keyup", function(event) {
            if(event.key != 'ArrowLeft' && event.key != 'ArrowRight') {
              clearStreet.classList.remove('d-none');
              let searchField = this.value;

              if(searchField === '' || searchField.includes('&#8291;') || searchField === ' ') {
                clearList(filter);
                clearStreet.classList.add('d-none');
                streetErrorEl.innerHTML = '';
                return;
              }

              // Check which courier type is selected
              const isMinkCourier = document.querySelector('#type-courier-new').checked;

              if (isMinkCourier) {
                // Split search input into street and house parts for Mink
                const searchParts = searchField.split(',').map(part => part.trim());
                const street = searchParts[0];
                const house = searchParts[1]?.replace(/^буд\.\s*/, '') || '';

                // Use different API endpoints based on whether house number is provided
                const apiUrl = house ?
                  `https://vr.mink.in.ua/get_houses?streetDetailed=${encodeURIComponent(street)}&house=${encodeURIComponent(house)}&city=${encodeURIComponent(properties._delivery_city_name || 'Київ')}` :
                  `https://vr.mink.in.ua/get_addresses?address=${encodeURIComponent(searchField)}&city=${encodeURIComponent(properties._delivery_city_name || 'Київ')}`;

                fetch(apiUrl)
                  .then(res => res.json())
                  .then(data => {
                    let output = '';
                    if (data && data.items && data.items.length > 0) {
                      data.items.forEach(val => {
                        const displayAddress = house ?
                          `${val.street}, буд.${val.houseNumber}` :
                          val.street;

                        output += `<a 
                        data-street="${val.street}"
                        data-house="${val.houseNumber || ''}" 
                        data-latitude="${val.latitude}"
                        data-longitude="${val.longitude}"
                        data-postcode="${val.postCode}"
                        class="street-link" 
                        href="javascript:void(0)" 
                        style="display:block;"
                      >${displayAddress}</a>`;
                      });
                      clearList(filter);
                      filter.insertAdjacentHTML('afterbegin', output);
                      document.getElementById('street_filter').classList.add('active');
                      streetErrorEl.innerHTML = '';

                      // Handle selection
                      document.querySelectorAll('a.street-link').forEach(street => {
                        street.addEventListener("click", function() {
                          const selectedStreet = this.getAttribute('data-street');
                          const selectedHouse = this.getAttribute('data-house');
                          const fullAddress = selectedHouse ?
                            `${selectedStreet}, буд.${selectedHouse}` :
                            selectedStreet;

                          // Set the combined value for Mink courier
                          inputStreet.value = fullAddress;
                          clearStreet.classList.remove('d-none');

                          // Update properties
                          properties._delivery_courier_street = selectedStreet;
                          properties._delivery_courier_house = selectedHouse ? `, буд.${selectedHouse}` : '';
                          properties._delivery_courier_address = fullAddress;
                          properties.latitude = this.getAttribute('data-latitude');
                          properties.longitude = this.getAttribute('data-longitude');
                          properties._delivery_postcode = this.getAttribute('data-postcode');

                          // Clear dropdown and update cart
                          clearList(filter);
                          document.getElementById('street_filter').classList.remove('active');

                          updateCartDeliveryAttr(properties)
                            .then(() => {
                              checkoutButton.classList.remove('disabled');
                              checkoutButton.disabled = false;
                            })
                            .catch(alert);
                        });
                      });
                    } else {
                      streetErrorEl.innerHTML = alertStreet;
                    }
                  })
                  .catch(error => {
                    console.error('Error fetching addresses:', error);
                    streetErrorEl.innerHTML = alertKeyboard;
                  });
              } else {
                // Use Nova Poshta API for street search
                reqAPI({
                  "apiKey": apiKey,
                  "modelName": "Address",
                  "calledMethod": "getStreet",
                  "methodProperties": {
                    "CityRef": cityRef,
                    "FindByString": searchField,
                    "Page": "1",
                    "Limit": ""
                  }
                })
                  .then(res => {
                    dataStreet = res.data;
                    if(dataStreet.length > 0) {
                      let output = '';
                      dataStreet.forEach(val => {
                        output += `<a 
                      data-ref="${val.Ref}" 
                      data-street="${val.StreetsType}${val.Description}" 
                      data-prefix="${val.StreetsType}" 
                      class="street-link" 
                      href="javascript:void(0)" 
                      style="display:block;"
                    >${val.StreetsType}${val.Description}</a>`;
                      });
                      clearList(filter);
                      filter.insertAdjacentHTML('afterbegin', output);
                      document.getElementById('street_filter').classList.add('active');
                      streetErrorEl.innerHTML = '';

                      document.querySelectorAll('a.street-link').forEach(street => {
                        street.addEventListener("click", function() {
                          const selectedStreet = this.getAttribute('data-street');

                          // Set input value and make readonly
                          inputStreet.value = selectedStreet;
                          inputStreet.setAttribute('readonly', true);
                          clearStreet.classList.remove('d-none');

                          // Clear dropdown
                          clearList(filter);
                          document.getElementById('street_filter').classList.remove('active');

                          // Update properties only on selection
                          properties._delivery_courier_street = selectedStreet;
                          properties._delivery_courier_address = selectedStreet;
                          properties._delivery_street_Ref = this.getAttribute('data-ref');

                          // Update cart attributes
                          updateCartDeliveryAttr(properties)
                            .then(() => {
                              checkoutButton.classList.remove('disabled');
                              checkoutButton.disabled = false;
                            })
                            .catch(alert);
                        });
                      });
                    } else {
                      streetErrorEl.innerHTML = alertStreet;
                    }
                  })
                  .catch(() => {
                    clearList(filter);
                    streetErrorEl.innerHTML = alertKeyboard;
                  });
              }
            }
          });

          // Remove the focusout event listener that was saving manual input
          inputStreet.removeEventListener("focusout", function() {});
        }


        /*== input build  ==*/
        window.initBuildingSearch = function() {
          const inputBuild = document.querySelector('#address-build');
          const buildFilter = document.createElement('div');
          buildFilter.id = 'building_filter';
          buildFilter.className = 'dropdown-filter';
          inputBuild.parentNode.appendChild(buildFilter);

          inputBuild.addEventListener("keyup", async function(event) {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') return;

            // Only proceed if Mink courier is selected
            const isMinkCourier = document.querySelector('#type-courier-new').checked;
            if (!isMinkCourier) return;

            const streetInput = document.querySelector('#address-street');
            if (!streetInput.value) {
              streetErrorEl.innerHTML = 'Спочатку оберіть вулицю';
              this.value = '';
              return;
            }

            let searchField = this.value.replace('буд.', '').trim();

            if (!searchField) {
              clearList(buildFilter);
              buildFilter.classList.remove('active');
              return;
            }

            try {
              const selectedCity = properties._delivery_city_name || 'Київ';
              const response = await fetch(`https://vr.mink.in.ua/get_houses?streetDetailed=${encodeURIComponent(streetInput.value)}&house=${encodeURIComponent(searchField)}&city=${encodeURIComponent(selectedCity)}`);
              const data = await response.json();

              if (data && data.items && data.items.length > 0) {
                let output = '';
                data.items.forEach(val => {
                  output += `<a 
                  data-house="${val.houseNumber}"
                  data-latitude="${val.latitude}"
                  data-longitude="${val.longitude}"
                  data-postcode="${val.postCode}"
                  class="building-link" 
                  href="javascript:void(0)" 
                  style="display:block;"
                >буд. ${val.houseNumber}</a>`;
                });

                clearList(buildFilter);
                buildFilter.insertAdjacentHTML('afterbegin', output);
                buildFilter.classList.add('active');

                // Handle building selection
                document.querySelectorAll('a.building-link').forEach(building => {
                  building.addEventListener("click", function() {
                    const selectedHouse = this.getAttribute('data-house');

                    // Update input and make it readonly
                    inputBuild.value = `буд.${selectedHouse}`;

                    // Hide dropdown
                    buildFilter.classList.remove('active');
                    clearList(buildFilter);

                    // Update properties
                    properties._delivery_courier_house = `, буд.${selectedHouse}`;
                    properties.latitude = this.getAttribute('data-latitude');
                    properties.longitude = this.getAttribute('data-longitude');
                    properties._delivery_postcode = this.getAttribute('data-postcode');

                    // Update full address
                    const street = properties._delivery_courier_street || '';
                    const flat = properties._delivery_courier_flat || '';
                    properties._delivery_courier_address = `${street}${properties._delivery_courier_house}${flat}`;

                    // Update cart attributes
                    updateCartDeliveryAttr(properties)
                      .then(() => {
                        checkoutButton.classList.remove('disabled');
                        checkoutButton.disabled = false;
                      })
                      .catch(alert);
                  });
                });
              }
            } catch (error) {
              console.error('Error fetching building numbers:', error);
            }
          });

          // Clear building selection when clicking clear button
          const clearBuildBtn = document.querySelector('.form-build .clear');
          if (clearBuildBtn) {
            clearBuildBtn.addEventListener('click', function() {
              inputBuild.value = '';
              inputBuild.removeAttribute('readonly');
              buildFilter.classList.remove('active');
              clearList(buildFilter);

              // Clear building-related properties
              properties._delivery_courier_house = null;
              properties.latitude = null;
              properties.longitude = null;

              // Update cart attributes
              updateCartDeliveryAttr(properties).catch(console.error);
            });
          }
        }

        // Initialize building search when DOM is loaded
        document.addEventListener('DOMContentLoaded', function() {
          initBuildingSearch();
        });

        // Remove the old building input handlers
        inputBuild.removeEventListener("keyup", function(){
          addressBuild = ', буд.'+this.value;
        });
        inputBuild.removeEventListener("focusout", function() {
          if (this.value) {
            addressBuild = `, буд.${this.value}`;
            properties._delivery_courier_house = addressBuild;

            // Update full address
            const street = properties._delivery_courier_street || '';
            const flat = properties._delivery_courier_flat || '';
            properties._delivery_courier_address = `${street}${addressBuild}${flat}`;

            updateCartDeliveryAttr(properties)
              .then(response => console.log('Updated with building:', response))
              .catch(console.error);
          }
        });
        /*== input flat  ==*/
        inputFlat.addEventListener("keyup", function(){
          addressFlat = ', кв.'+this.value;
        })
        inputFlat.addEventListener("focusout", function() {
          if (this.value) {
            addressFlat = `, кв.${this.value}`;
            properties._delivery_courier_flat = addressFlat;

            // Update full address
            const street = properties._delivery_courier_street || '';
            const building = properties._delivery_courier_house || '';
            properties._delivery_courier_address = `${street}${building}${addressFlat}`;

            updateCartDeliveryAttr(properties)
              .then(response => console.log('Updated with flat:', response))
              .catch(console.error);
          }
        });

        const entranceInput = document.querySelector('#address-entrance');
        const floorInput = document.querySelector('#address-floor');

        entranceInput.addEventListener("change", async function() {
          if (this.value) {
            properties._delivery_entrance = this.value;
            await updateFullAddress();
          }
        });

        floorInput.addEventListener("change", async function() {
          if (this.value) {
            properties._delivery_floor = this.value;
            await updateFullAddress();
          }
        });

        async function updateFullAddress() {
          const street = properties._delivery_courier_street || '';
          const house = properties._delivery_courier_house || '';
          const flat = properties._delivery_courier_flat || '';
          const entrance = properties._delivery_entrance ? `, під'їзд ${properties._delivery_entrance}` : '';
          const floor = properties._delivery_floor ? `, поверх ${properties._delivery_floor}` : '';

          properties._delivery_courier_address = `${street}${house}${flat}${entrance}${floor}`;

          await updateCartDeliveryAttr(properties);
        }
        function addErrorMessage() {
          const errorContainer = document.querySelector('.cart-terms .alert-danger');

          if (!errorContainer) return false;

          if (errorContainer && !(errorContainer.getAttribute('added-text'))) {
            errorContainer.innerHTML += ` ${translations?.shipping_method?.title}`;

            errorContainer.setAttribute('added-text', 'true');

            return true;
          }
        }
        const errorInterval = setInterval(() => {
          const isSet = addErrorMessage();

          if (isSet !== false) clearInterval(errorInterval);
        }, 100);


        checkoutButton.addEventListener('click', async function(e) {
          e.preventDefault();
          this.disabled = true;
          this.classList.add('disabled');

          try {
            const [cartData, crmHtml] = await Promise.all([
              fetch(`${cartUrl}.json`).then(response => response.json()),
              fetch('/cart?view=ajax').then(response => response.text())
            ]);

            const params = new URLSearchParams();

            if (document.querySelector('#type-courier-new').checked && cartData.attributes._delivery_courier_new === 'mink') {
              // Get all address components
              const street = cartData.attributes._delivery_courier_street || '';
              const house = cartData.attributes._delivery_courier_house?.replace(', буд.', '') || '';
              const flat = cartData.attributes._delivery_courier_flat?.replace(', кв.', '') || '';
              const entrance = cartData.attributes._delivery_entrance ? `, під'їзд ${cartData.attributes._delivery_entrance}` : '';
              const floor = cartData.attributes._delivery_floor ? `, поверх ${cartData.attributes._delivery_floor}` : '';

              // Construct full address with proper formatting
              const fullAddress = `${street}, буд.${house}${flat}${entrance}${floor}`.trim();

              params.append('checkout[shipping_address][address1]', fullAddress);

              // Get clean city name without region
              const cityName = cartData.attributes._delivery_city_name ||
                cartData.attributes._delivery_city?.replace(/, .* обл\.$/, '') || '';
              params.append('checkout[shipping_address][city]', cityName);

              params.append('checkout[shipping_address][country]', 'Ukraine');
              params.append('checkout[shipping_address][zip]', cartData.attributes._delivery_postcode || '12345');
              params.append('checkout[shipping_address][phone]', '');

              // Add delivery date and time window
              if (cartData.attributes['Selected Delivery Date']) {
                params.append('checkout[shipping_address][company]', cartData.attributes['Selected Delivery Date']);
              }
              if (cartData.attributes['Selected Delivery Times']) {
                params.append('checkout[shipping_address][address2]', cartData.attributes['Selected Delivery Times']);
              }
            } else {
              params.append('checkout[shipping_address][first_name]', '');
              params.append('checkout[shipping_address][last_name]', '');

              if (cartData.attributes._delivery_courier_address) {
                params.append('checkout[shipping_address][address1]', cartData.attributes._delivery_courier_address);
              } else if (cartData.attributes._delivery_warehouse) {
                params.append('checkout[shipping_address][address1]', cartData.attributes._delivery_warehouse);
              }

              const city = cartData.attributes._delivery_city?.replace(/, .* обл\.$/, '') || '';
              params.append('checkout[shipping_address][city]', city);
              params.append('checkout[shipping_address][country]', 'Ukraine');

              const zipCode = cartData.attributes._delivery_postcode ||
                cartData.attributes._delivery_warehouse_zip ||
                '12345';
              params.append('checkout[shipping_address][zip]', zipCode);
              params.append('checkout[shipping_address][phone]', '');
            }

            // Add UTM parameters
            params.append('utm_source', 'google');
            params.append('utm_medium', 'cpc');
            params.append('utm_campaign', 'Performance_max');

            // Redirect to checkout
            const checkoutUrl = `/checkout?${params.toString()}`;
            console.log('Final Checkout URL:', checkoutUrl);
            window.location.href = checkoutUrl;

          } catch (error) {
            console.error('Error preparing checkout:', error);
            this.disabled = false;
            this.classList.remove('disabled');
          }
        });

        NovaPoshtaLoad = true;
        window.globalSearchCity();

        // Dispatch custom event when NP is loaded
        const npLoadedEvent = new CustomEvent('np-widget-loaded');
        document.dispatchEvent(npLoadedEvent);

      } else {

        errorAPI();

      }
    })
    .catch(err => {
      errorAPI();
    })

  /*== Error API ==*/
  function errorAPI() {
    document.querySelector('.checkout-button-wrap').classList.remove('tool');
    console.log('error');
    /*== check selected delivery type ==*/
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

      wrapWarehouse.classList.add('d-none');
      // wrapAddresses.classList.add('d-none');
      //alert('1');

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
        deliveryType = data.attributes._delivery_type;

        if(deliveryType == 'courier') {

          filterExclusion = '-1';
          wrapAddresses.classList.remove('d-none');
          properties._delivery_method  = methodCourier;
          checkoutButton.disabled = false;
          //checkoutButtonWrapper.classList.remove('tool');
          //if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;

        } else {

          filterExclusion = '0';
          wrapWarehouse.classList.remove('d-none');
          properties._delivery_type = deliveryType;
          properties._delivery_method = methodBranch;

        }
      }
      if (!isDelivery) {
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
        properties._delivery_method = methodBranch;
        filterExclusion = '0';
      }

      properties._delivery_courier_address              = null;
      properties._delivery_courier_street               = null;
      properties._delivery_courier_house                = null;
      properties._delivery_courier_flat                 = null;
      properties._delivery_street_Ref                   = null;
      properties._delivery_city                         = null;
      properties._delivery_city_Area                    = null;
      properties._delivery_city_Ref                     = null;
      properties._delivery_warehouse                    = null;
      properties._delivery_warehouse_zip                = null;
      properties._delivery_warehouse_name               = null;
      properties._delivery_warehouse_address            = null;
      properties._delivery_warehouse_CityRef            = null;
      properties._delivery_warehouse_Number             = null;
      properties._delivery_warehouse_Ref                = null;
      properties._delivery_warehouse_SettlementRef      = null;
      properties._delivery_warehouse_TypeOfWarehouse    = null;

      updateCartDeliveryAttr(properties);


      //updateCartNote();

    })

    courierTypes.forEach(function(el){
      el.addEventListener("change", async function(){
        const selectedValue = this.value;
        const cityWrapper = document.querySelector('.form-city');
        const quickCityWrap = document.querySelector('.quick-city-wrap');
        const npFieldsWrap = document.querySelector('.np-fields-wrap');
        const warehouseWrap = document.querySelector('.warehouse-wrap');
        const addressWrap = document.querySelector('.address-wrap');
        const extraFields = document.querySelectorAll('.form-entrance, .form-floor');
        const cityInput = document.querySelector('#city-search');
        const npRadioWrap = document.querySelector('.np-fields-wrap');

        // Reset NP radio selection when switching courier types
        if (npRadioWrap) {
          const npRadios = npRadioWrap.querySelectorAll('input[type="radio"]');
          npRadios.forEach(radio => radio.checked = false);
        }

        if (selectedValue === 'mink') {
          // Hide NP specific elements
          quickCityWrap.classList.add('tw-hidden');
          npFieldsWrap.classList.add('tw-hidden');
          warehouseWrap.classList.add('tw-hidden');

          // Show address fields and extra fields for Mink
          addressWrap.classList.remove('tw-hidden');
          extraFields.forEach(field => field.classList.remove('tw-hidden'));

          // Update cart attributes for Mink courier
          await updateCartDeliveryAttr({
            _delivery_courier_new: 'mink',
            _delivery_type: 'courier'
          });
        } else {
          // Show NP specific elements
          quickCityWrap.classList.remove('tw-hidden');
          npFieldsWrap.classList.remove('tw-hidden');

          // Set default NP radio selection
          const courierRadio = document.querySelector('#type-courier');
          if (courierRadio) {
            courierRadio.checked = true;
            deliveryType = 'courier';
          }

          // Hide extra fields for Nova Poshta
          extraFields.forEach(field => field.classList.add('tw-hidden'));

          // Update cart attributes for NP courier
          await updateCartDeliveryAttr({
            _delivery_courier_new: 'np',
            _delivery_type: 'courier'
          });
        }
      });
    });

    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el){
      el.addEventListener("change", function(){
        const warehouseWrap = document.querySelector('.warehouse-wrap');
        const extraFields = document.querySelectorAll('.form-entrance, .form-floor');
        const courierNew = document.querySelector('#type-courier-new');

        deliveryType = this.getAttribute('data-type');

        if (deliveryType === 'branch') {
          // Show warehouse selection, hide address fields
          warehouseWrap.classList.remove('tw-hidden');
          extraFields.forEach(field => field.classList.add('tw-hidden'));

          // Reset courier type selection
          if (courierNew.checked || npCourier.checked) {
            npCourier.checked = false;
            courierNew.checked = false;
          }
        } else if (deliveryType === 'courier') {
          // Hide warehouse selection
          warehouseWrap.classList.add('tw-hidden');

          // Show address fields only for Mink courier
          if (courierNew.checked) {
            addressWrap.classList.remove('tw-hidden');
            extraFields.forEach(field => field.classList.remove('tw-hidden'));
          } else if (npCourier.checked) {
            addressWrap.classList.remove('tw-hidden');
            extraFields.forEach(field => field.classList.add('tw-hidden'));
          }
        }

        wrapWarehouse.classList.add('d-none');
        // wrapAddresses.classList.add('d-none');
        inputFields.forEach(function(e){ e.value = '';})
        cityErrorEl.innerHTML = '';
        warehouseErrorEl.innerHTML = '';
        streetErrorEl.innerHTML = '';


        properties._delivery_type = deliveryType;
        if (deliveryType == 'branch') {
          properties._delivery_method = methodBranch;
          wrapWarehouse.classList.remove('d-none');
          //if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
        } else {
          properties._delivery_method = methodCourier;
          wrapAddresses.classList.remove('d-none');
          checkoutButton.classList.remove('disabled');
          checkoutButton.disabled = false;
          //if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;
        }
        properties._delivery_courier_address              = null;
        properties._delivery_courier_street               = null;
        properties._delivery_courier_house                = null;
        properties._delivery_courier_flat                 = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties).then(function() {/*console.log(cart)*/}).catch(alert);
      })
    })
    /*== update cart attribute  ==*/
    async function updateCartDeliveryAttr(data) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ attributes: data}),
          credentials: 'same-origin',
          cache: 'no-cache',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        return response.json();
      } catch (error) {
        throw error;
      }
    }
    checkoutButton.addEventListener('click', async function(e) {

      let shouldDisable = true;
      if (shouldDisable) this.classList.add('disabled');

      e.preventDefault();
      this.disabled = true;


      addressStreet = addressCity = addressWarehouse = false;
      if(inputStreet.value) addressStreet = 'вул.'+inputStreet.value; //(addressStreet)?addressStreet:'';
      if(inputBuild.value) addressStreet = addressStreet +' буд.'+inputBuild.value;
      if(inputFlat.value) addressStreet = addressStreet +' кв.'+inputFlat.value;
      if(inputCity.value) addressCity = inputCity.value; //(addressCity)?addressCity:'';
      if(inputWarehouse.value) addressWarehouse = inputWarehouse.value;
      addressZip = '12345';

      properties._delivery_courier_address              = (addressStreet != false ) ? addressStreet : null;
      properties._delivery_city                         = (addressCity != false ) ? addressCity : null;
      properties._delivery_warehouse_zip                = addressZip;
      properties._delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : null;

      updateCartDeliveryAttr(properties);

      let addr_delivery_courier_address              = (addressStreet != false ) ? addressStreet : '';
      let addr_delivery_city                         = (addressCity != false ) ? addressCity : '';
      let addr_delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : '';

      const address = ({
        address1: (deliveryType == 'branch') ? 'відділення/поштомат '+addr_delivery_warehouse_Number : addr_delivery_courier_address+' ('+methodCourier+')',
        zip: addressZip,
        city: addr_delivery_city,
        country: country
      });

      setTimeout( function() {
        fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
          const pairs = [];

          const path = data.items.map(item => {
            return `${item.variant_id}:${item.quantity}`;
          }).join(',');

          for (var key in properties) {
            const value = properties[key];

            if (!value) continue;

            const pair = `attributes[${key}]=${properties[key]}`;

            pairs.push(pair);
          }

          for (var key in address) {
            const value = address[key];

            if (!value) continue;

            const pair = `checkout[shipping_address][${key}]=${address[key]}`;

            pairs.push(pair);
          }

          let query;
          let url;
          if (data.note && data.note != null) {
            query = pairs.join('&') + `&note=${data.note}`;
            url = `${cartUrl}/${path}?${query}`;
          } else {
            query = pairs.join('&');
            url = `${cartUrl}/${path}?${query}`;
          }


          const delivery_info = `&checkout[shipping_address][company]=${data.attributes['Selected Delivery Date']}&checkout[shipping_address][address2]=${data.attributes['Selected Delivery Times']}`;
          const delivery_url = url + delivery_info;
          const formatted_delivery_url = delivery_url.replace('undefined', '');
          window.location.href = formatted_delivery_url;
          console.log(formatted_delivery_url, 'dleivery ul 1');
        })



      },200);

    });
  }

}


window.checkFields = function() {
  let make_redirect = true;
  if (!document.querySelector('input#address-street').value){
    make_redirect = false;
  }
  if (!document.querySelector('input#city-search').value){
    make_redirect = false;
  }
  if (!document.querySelector('input#address-build').value){
    make_redirect = false;
  }


  if (!document.querySelector('input#address-flat').value && document.querySelector('input#private-house').checked == false ){
    make_redirect = false;
  }

  if (!document.querySelector('input#address-entrance').value && document.querySelector('input#type-courier-new').checked && document.querySelector('input#private-house').checked == false){
    make_redirect = false;
  }

  if (!document.querySelector('input#address-floor').value && document.querySelector('input#type-courier-new').checked && document.querySelector('input#private-house').checked == false){
    make_redirect = false;
  }


  if(document.querySelector('input#type-courier-new').checked || document.querySelector('#type-courier').checked) {
    const privateHouse = document.getElementById('private-house');

    if(privateHouse){
      const privateHouseContainer = document.querySelector('.private-house-wrap');
      privateHouseContainer.classList.remove("tw-hidden");

      privateHouse.addEventListener('change', function () {
        if (this.checked) {
          const parentContainer = document.querySelector("#nova-poshta");

          if(parentContainer){
            parentContainer.classList.add("is-house");
          }

          if (!document.querySelector('input#address-flat').value){
            make_redirect = true;
          }

          if (!document.querySelector('input#address-entrance').value && document.querySelector('input#type-courier-new').checked ){
            make_redirect = true;
          }
          if (!document.querySelector('input#address-floor').value && document.querySelector('input#type-courier-new').checked){
            make_redirect = true;
          }
        } else {
          const parentContainer = document.querySelector("#nova-poshta");

          if(parentContainer){
            parentContainer.classList.remove("is-house");
          }
        }
      });
    }

  }else {
    const privateHouseContainer = document.querySelector('.private-house-wrap');
    privateHouseContainer.classList.add("tw-hidden");
  }










  if (document.querySelector('input#type-courier-new').checked && document.querySelector('.delivery-widget__input-value').textContent.trim() == 'Коли приїхати курʼєру' ){
    make_redirect = false;
  }

  if (document.querySelector('#type-courier-new-np').checked && document.querySelector('[data-type="branch"]').checked && document.querySelector('input#city-search').value != '' && document.querySelector('#warehouse-search').value != '' ) {
    make_redirect = true;
  }

  if (!make_redirect) {
    document.querySelector('.cart-drawer .cart__checkout-button').disabled = true;
    document.querySelector('.cart-drawer .cart__checkout-button').classList.add('disabled');
  } else {
    document.querySelector('.cart-drawer .cart__checkout-button').disabled = false;
    document.querySelector('.cart-drawer .cart__checkout-button').classList.remove('disabled');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  setInterval(() => {
    window.checkFields();
  }, 1500);
});

document.querySelectorAll('[name="courier-type"]').forEach(radio => {
  radio.addEventListener('change', function() {
    const isMinkCourier = this.value === 'mink';
    updateFieldsVisibility(isMinkCourier);

    // Clear existing results when switching courier types
    const filter = document.querySelector('#street_filter');
    clearList(filter);
    document.querySelector('.input-street').value = '';
  });
});


// Initialize all handlers
document.addEventListener('DOMContentLoaded', function() {
  // Initial setup
  const isMinkCourier = document.querySelector('#type-courier-new').checked;
  updateFieldsVisibility(isMinkCourier);

  // Set up validation interval
  setInterval(() => {
    validateDeliveryFields();
  }, 500);
});

// Add helper function to handle visibility
function updateFieldsVisibility() {
  //console.log('updateFieldsVisibility');
  const isMinkCourierLocal = document.querySelector('#type-courier-new').checked;
  const streetInput = document.querySelector('#address-street');
  const streetLabel = streetInput.nextElementSibling;
  const extraFields = document.querySelectorAll('.form-entrance, .form-floor');

  if (isMinkCourierLocal) {
    extraFields.forEach(field => field.classList.remove('tw-hidden'));
  } else {
    extraFields.forEach(field => field.classList.add('tw-hidden'));
  }
}

document.addEventListener('DOMContentLoaded', function() {
  updateFieldsVisibility();
});


function validateDeliveryFields() {
  const typeBranch = document.querySelector('#type-branch');
  const typeCourier = document.querySelector('#type-courier');
  const courierMink = document.querySelector('#type-courier-new');
  const warehouseWrap = document.querySelector('.warehouse-wrap');
  const addressWrap = document.querySelector('.address-wrap');

  if (typeBranch && typeBranch.checked) {
    // Branch selected
    document.querySelector('#address-street').value = '';
    document.querySelector('#address-build').value = '';
    document.querySelector('#address-flat').value = '';
    warehouseWrap.classList.remove('tw-hidden');
    addressWrap.classList.add('tw-hidden');
  } else if (typeCourier && typeCourier.checked) {
    // Courier selected
    document.querySelector('#warehouse-search').value = '';
    warehouseWrap.classList.add('tw-hidden');
    addressWrap.classList.remove('tw-hidden');

    // Use the consolidated function for courier-specific visibility
    updateFieldsVisibility(courierMink?.checked);
  }
}

// Add this near your other DOMContentLoaded listeners
document.addEventListener('DOMContentLoaded', function() {
  // Initial validation
  validateDeliveryFields();

  // Set up interval for continuous validation
  setInterval(validateDeliveryFields, 500);
});


// In the street selection handler (for both Mink and Nova Poshta)
function handleStreetSelection(streetElement) {
  console.log('handleStreetSelection', streetElement);
  const streetInput = document.querySelector('#address-street');
  const streetFilter = document.querySelector('#street_filter');
  const clearStreetBtn = document.querySelector('.form-street .clear');

  // Set the selected value
  streetInput.value = streetElement.textContent;
  streetInput.dataset.ref = streetElement.getAttribute('data-ref');

  // Make input readonly and show clear button
  clearStreetBtn.classList.remove('d-none');

  // Hide dropdown
  streetFilter.classList.remove('active');
  clearList(streetFilter);
}


// Add this function to handle street input state
function updateStreetInputState() {
  const streetInput = document.querySelector('#address-street');
  const clearStreetBtn = document.querySelector('.form-street .clear');

  if (streetInput && streetInput.value.trim() !== '') {
    // If street has value, make it readonly and show clear button
    if (clearStreetBtn) {
      clearStreetBtn.classList.remove('d-none');
    }
  }
}

// Modify the existing validateDeliveryFields function
function validateDeliveryFields() {
  const typeBranch = document.querySelector('#type-branch');
  const typeCourier = document.querySelector('#type-courier');
  const courierMink = document.querySelector('#type-courier-new');
  const courierNP = document.querySelector('#type-courier-new-np');
  const warehouseWrap = document.querySelector('.warehouse-wrap');
  const addressWrap = document.querySelector('.address-wrap');

  // Clear both inputs when switching types
  if (typeBranch && typeBranch.checked) {
    // Branch selected
    document.querySelector('#address-street').value = '';
    document.querySelector('#address-build').value = '';
    document.querySelector('#address-flat').value = '';
    warehouseWrap.classList.remove('tw-hidden');
    addressWrap.classList.add('tw-hidden');
  } else if (typeCourier && typeCourier.checked) {
    // Courier selected
    document.querySelector('#warehouse-search').value = '';
    warehouseWrap.classList.add('tw-hidden');
    addressWrap.classList.remove('tw-hidden');

    // Use the consolidated function for courier-specific visibility
    updateFieldsVisibility(courierMink?.checked);
  }

  // Check street input state
  updateStreetInputState();
}

// Update DOMContentLoaded listener
document.addEventListener('DOMContentLoaded', function() {
  // Initial validation
  validateDeliveryFields();
  updateStreetInputState();

  // Set up intervals for continuous validation
  setInterval(validateDeliveryFields, 500);
});

document.addEventListener('np-widget-loaded', function() {
  let intervalCount = 0;
  const cityCheckInterval = setInterval(() => {
    let cityInput = document.querySelector('#city-input');

    if (cityInput && cityInput.value.includes('м. Київ')) {
      intervalCount++;

      const minkButton = document.querySelector('.mink-btn');
      const minkNotify = document.querySelector('.mink-notify');
      const hiddenMask = document.querySelector('.hidden-click-mask');

      // Enable Mink button
      minkButton.classList.remove('courier-disabled');
      minkNotify.classList.add('tw-hidden');
      hiddenMask.classList.add('tw-hidden');

      // Update cart attributes
      properties._delivery_city = cityInput.value;
      updateCartDeliveryAttr(properties);

      // Clear interval after running twice
      if (intervalCount >= 2) {
        clearInterval(cityCheckInterval);
      }
    }
  }, 2000);
});


// Replace DOMContentLoaded listeners with np-widget-loaded
document.addEventListener('np-widget-loaded', function() {
  // Initial validation
  validateDeliveryFields();
  updateStreetInputState();
  initBuildingSearch();

  // Set up intervals for continuous validation
  setInterval(validateDeliveryFields, 500);
  setInterval(() => {
    window.checkFields();
  }, 1500);
});

document.addEventListener('np-widget-loaded', function() {
  const cityInput = document.querySelector('#city-search');
  const cityRef = cityInput?.getAttribute('data-ref');
  const deliveryType = document.querySelector('input[type="radio"][name="id"]:checked')?.getAttribute('data-type');

  if (cityRef && deliveryType === 'branch') {
    window.globalReqAPI({
      "apiKey": apiKey,
      "modelName": "Address",
      "calledMethod": "getWarehouses",
      "methodProperties": {"CityRef": cityRef}
    })
      .then(function(res) {
        if (res.success) {
          dataWarehouses = res.data;
          searchWarehouse(dataWarehouses);
        }
      })
      .catch(console.error);
  }
});

// Clear button functionality
if (document.querySelector('.form-street .clear')){
  document.querySelector('.form-street .clear').addEventListener('click', function() {
    const streetInput = document.querySelector('#address-street');
    const streetFilter = document.querySelector('#street_filter');

    // Clear input
    streetInput.value = '';
    streetInput.dataset.ref = '';

    // Hide clear button
    this.classList.add('d-none');

    // Clear dropdown
    if (streetFilter) {
      clearList(streetFilter);
      streetFilter.classList.remove('active');
    }

    // Clear related properties
    properties._delivery_courier_street = null;
    properties._delivery_courier_address = null;
    properties._delivery_street_Ref = null;
    properties.latitude = null;
    properties.longitude = null;
    properties._delivery_postcode = null;

    // Update cart attributes
    updateCartDeliveryAttr(properties).catch(console.error);

    // Focus the input
    streetInput.focus();
  });
}

// Put this anywhere in your global script (e.g., near NovaPoshtaMain)
window.initWarehouseSearch = function() {
  const warehouseInput = document.querySelector('#warehouse-search');
  const warehouseFilter = document.querySelector('#warehouse_filter');
  const warehouseErrorEl = document.querySelector('.warehouse-wrap .input-error');

  // If not found, exit
  if (!warehouseInput) return;

  // Remove existing event listeners by cloning if needed (optional)
  const newInput = warehouseInput.cloneNode(true);
  warehouseInput.parentNode.replaceChild(newInput, warehouseInput);

  // Listen for user input
  newInput.addEventListener('input', function(event) {
    const searchField = event.target.value.trim();
    if (!searchField) {
      clearList(warehouseFilter); // Your helper to remove all child nodes
      // Possibly hide the dropdown
      warehouseFilter.classList.remove('active');
      return;
    }

    // Make the request to NP
    window.globalReqAPI({
      apiKey: apiKey,
      modelName: "Address",
      calledMethod: "getWarehouses",
      methodProperties: {
        "CityRef": properties._delivery_city_Ref,
        "FindByString": searchField,
        "Limit": 50
      }
    })
      .then(function(res) {
        // Clear old results
        clearList(warehouseFilter);

        if (!res.success || !res.data || !res.data.length) {
          warehouseErrorEl.innerHTML = alertWarehouse;
          return;
        }

        // Generate the dropdown
        let output = '';
        res.data.forEach(function(val) {
          output += `
          <a 
            data-val='${JSON.stringify(val)}' 
            class='warehouse-link' 
            href='javascript:void(0)'
            style='display:block;'
          >
            ${val.Description}
          </a>`;
        });

        warehouseFilter.insertAdjacentHTML('afterbegin', output);
        warehouseFilter.classList.add('active');
        warehouseErrorEl.innerHTML = '';

        // Bind click on each result
        document.querySelectorAll('.warehouse-link').forEach(link => {
          link.addEventListener('click', function() {
            const warehouseData = JSON.parse(this.getAttribute('data-val'));

            // Populate input with user's selection
            newInput.value = warehouseData.Description;
            newInput.readOnly = true;

            // Update your cart attributes (properties)
            properties._delivery_warehouse = warehouseData.Description;
            properties._delivery_warehouse_Ref = warehouseData.Ref;
            // etc. for all needed attributes

            // Re-run your updateCartDeliveryAttr
            updateCartDeliveryAttr(properties)
              .then(() => {
                // For example, re-enable checkout button
                checkoutButton.disabled = false;
                checkoutButton.classList.remove('disabled');

                // Hide the dropdown
                warehouseFilter.classList.remove('active');
                clearList(warehouseFilter);
              })
              .catch(console.error);
          });
        });
      })
      .catch(error => {
        console.error('Error fetching warehouses:', error);
        warehouseErrorEl.innerHTML = alertKeyboard;
      });
  });
};

// Simple helper to clear the dropdown list
function clearList(parentEl) {
  while (parentEl.firstChild) {
    parentEl.removeChild(parentEl.firstChild);
  }
}
